<template>
  <div
    class="hover:bg-primary-200 flex cursor-pointer items-center gap-x-4 rounded-md bg-neutral-50 p-3"
  >
    <div
      class="flex max-h-12 max-w-12 shrink-0 items-center justify-center rounded-md"
    >
      <slot v-if="!icon" name="icon" />
      <TIcon v-else :name="icon" />
    </div>
    <div>
      <TH2 class="text-neutral-950">
        <slot v-if="!title" name="title" />
        <span v-else>{{ title }}</span>
      </TH2>
      <TP1 class="text-neutral-500"
        ><slot v-if="!description" name="description" />
        <span v-else>{{ description }}</span>
      </TP1>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TIcon from '../Icon/TIcon.vue';
import type { IconType } from '../Icon/icon';
import TH2 from '../TH2.vue';
import TP1 from '../TP1.vue';
defineProps<{
  title?: string;
  description?: string;
  icon?: IconType;
}>();
</script>
